/* export function login(state, auth) {
    state.status = true
} */

import { defaultFiltroTicket, defaultObservacion, defaultTicket, defaultTicketDetalle } from "./state";

/**
 * Mutación que carga los estados de un producto químico en el formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} estados contiene la información de los estados de un producto químico.
 */
export function cargarEstados(state, estados) {

    state.estadosBusqueda = [];
    state.estados = [];
    state.estados = estados.map(item => {
        let status = '';
        if (item.lista == 'Pendiente') {
            status = 'Abierto';
        } else if (item.lista == 'En Progreso') {
            status = 'En Progreso';
        } else if (item.lista == 'Cancelado') {
            status = 'Pendiente';
        } else if (item.lista == 'Finalizado') {
            status = 'Cerrado';
        }
        return {
            value: item.id,
            text: status,
        }
    });
    state.estadosBusqueda = structuredClone(state.estados);
    state.estadosBusqueda.push({value: 0, text: 'Todos'});
}

/**
 * Mutación para asignar o designar tickets.
 *
 * @export
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} data contiene el id del ticket y el state del checkbox
 */
export function setTicketsSeleccionados(state, data) {
    if (data.state) {
        if (!state.ticketsSeleccionados.some((t) => t == data.id)) {
            state.ticketsSeleccionados.push(data.id);
        }
    } else {
        if (state.ticketsSeleccionados.some((t) => t == data.id)) {
            const index = state.ticketsSeleccionados.findIndex((t) => t == data.id);
            if (index >= 0) {
                state.ticketsSeleccionados.splice(index, 1);
            }
        }
    }
}

/**
 * Mutación que carga los estados de un producto químico en el formulario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} estados contiene listado de usuarios
 */
export function setUsuarios(state, usuarios) {

    state.usuarios = [];
    state.usuarios.push({ value: 0, text: 'Todos' });

    for (var i = 0; i < usuarios.data.length; i++) {
        state.usuarios.push({ value: usuarios.data[i].id, text: usuarios.data[i].name });
    }
}

/**
 * Mutación para visualizar informes procesados.
 *
 * @export
 * @param {*} state
 * @param {*} data
 */
export function setInformesProcesados(state, data) {
    state.informesProcesados = data;
}

/**
 * Mutación para limpiar los tickets seleccionados.
 *
 * @export
 * @param {*} state
 */
export function setDefaultTicketsSeleccionados(state) {
    state.ticketsSeleccionados = [];
    state.marcadosPagina       = false;
}

/**
 * Mutación que carga la información del reporte de tickets.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} data contiene la información del reporte de tickets.
 */
 export function setTicketsReport(state, data) {
    state.tickets_report = data.data;
}

/**
 * Mutación para limpiar el formulario de creación de tickets.
 *
 * @export
 * @param {*} state
 */
export function resetSelectedTicket(state) {
    Object.assign(state.selectedTicket, defaultTicket());
}

/**
 * Mutación para asignar información al ticket en el formulario de creación.
 *
 * @export
 * @param {*} state
 * @param {*} data
 */
export function assignDataSelectedTicket(state, data) {
    Object.assign(state.selectedTicket, data);
}

/**
 * Mutación para cargar los mensajes paramétricos para respuesta masiva de tickets.
 *
 * @export
 * @param {*} state
 * @param {*} mensajesMasivos
 */
export function setMensajesMasivos(state, mensajesMasivos) {
    state.mensajesMasivos = mensajesMasivos.data;
}

export function ticketError(state) {
    console.log(state);
    console.log('ticketError');
}

/**
 * Mutación para marcar o desmarcar tickets en lote.
 *
 * @export
 * @param {*} state
 * @param {*} accion
 */
 export function setMarcarDesmarcarTodos(state, accion) {
    state.marcadosPagina = accion;
    if (!accion) {
        state.ticketsSeleccionados = [];
    }
    if (state.tickets.data) {
        state.tickets.data.forEach((p) => {
            if (state.marcadosPagina) {
                if (!state.ticketsSeleccionados.some((t) => t == p.id)) {
                    let data = {id: p.id, state: true};
                    setTicketsSeleccionados(state, data);
                }
            } else {
                let data = {id: p.id, state: false};
                setTicketsSeleccionados(state, data);
            }
        });
    }
}

/**
 * Mutación para marcar o desmarcar el checkbox del selector en lote.
 *
 * @export
 * @param {*} state
 */
 export function setMarcarCheckTodos(state) {
    let bool = false;
    state.tickets.data.forEach((p) => {
        if (state.ticketsSeleccionados.some((t) => t == p.id)) {
            bool = true;
        } else {
            bool = false;
            return true;
        }
    });
    state.marcadosPagina = bool;
}

export function setListarTickets(state, tickets) {
    state.tickets = [];

    if (tickets.data.length) {
        tickets.data.forEach(element => {
            if (state.ticketsSeleccionados.some((t) => t == element.id)) {
                element.checked = true;
            } else {
                element.checked = false;
            }
        });
    }
    state.tickets = tickets;
    setMarcarCheckTodos(state);
}

export function cambiaTicketId(state, datos) {
    Object.assign(state.ticket_detalle, datos);
}

export function limpiarTicket(state) {
    state.selectedTicket = {
        asunto: '',
        nombre: '',
        email: '',
        adjunto: '',
        mensaje: ''
    }
}

/**
 * Mutación para cambiar la pagina de las observaciones masivas de los tickets.
 *
 * @param {*} param0
 * @param {*} page contiene la pagina.
 */
 export async function setPageMasivo(state, data) {
    state.filtrosListas.page = data;
}

/**
 * Mutación para cambiar la cantidad por pagina de las observaciones masivas de los tickets.
 *
 * @export
 * @param {*} {commit, dispatch, state}
 * @param {*} perPage
 */
export async function setPerPageMasivo(state, data) {
    state.filtrosListas.perPage = data;
}

export function asignacionTicket(state, data) {
    state.asignacionTicket = data;
}
export function marcarLeido(state) {

    state.vistoUsuario.check = 1;

}


export function setObservaciones(state, data) {

    state.observaciones = data;
}
export function setVisto(state, data) {

    state.visto = data;
}

export function limpiarObservacion(state) {
    state.selectedObservacion.observacion = '';
}

export function setEmpresas(state, empresas) {
    state.empresas = empresas
}

export function setPage(state, page) {

    state.filtroEt.page = page
}

export function setPerPage(state, perPage) {
    state.filtroEt.page = 1
    state.filtroEt.perPage = perPage
}

export function setPantalla(state, pagina) {

    state.pantalla = pagina

}


export function setLoading(state, estado) {

    state.loading = estado

}

export function setFiltro(state, buscar) {
    Object.assign(state.filtroEt, buscar);
}

/**
 * Mutación para limpiar el formulario de tickets.
 *
 * @export
 * @param {*} state
 */
export function resetFiltro(state) {
    Object.assign(state.filtroEt, defaultFiltroTicket());
}

/**
 * Mutación para limpiar el formulario del detalle de tickets.
 *
 * @export
 * @param {*} state
 */
export function resetObservacion(state) {
    Object.assign(state.selectedObservacion, defaultObservacion());
}

export function setRol(state, tipo) {
    if (tipo == 'admin' || tipo == 'superadmin') {
        state.esAdmin = true;
        state.esEmpresa = false;
    } else {
        state.esEmpresa = true;
        state.esAdmin = false;
    }
    if (tipo == 'superadmin') {
        state.esSuperAdmin = true;
        state.esAdmin = true;
        state.esEmpresa = false;
    }
}

/**
 * Actualizar el ticket cerrado
 *
 * @param data
 */
export async function updateTicket(state, data) {
    state.ticket_detalle = data;
}

/**
 * Reseatear la información del Ticket.
 * @param Object state
 */
export function resetDetailsTicket(state) {
    state.ticket_detalle = defaultTicketDetalle()
}

/*
*
*
 */
export function addObservation(state, data) {

    state.observaciones.push(data);
}

/**
 * Agregar informacion para graficas
 *
 * @param data
 */
export async function setInfoCharts(state, data) {
    state.tickets_chart = data;
}

/**
 * Manipula los fabricantes.
 *
 * @param nextState
 */
export async function setManufacturers(state, nextState) {
    state.manufacturers = nextState;
}


/**
 * Actualiza la empresa seleccionada.
 *
 * @param selectedCompany
 */
export async function setSelectedCompany(state, selectedCompany) {
    state.selectedCompany = selectedCompany;
}
